import React from "react";
import { FormProvider } from "react-hook-form";
import { Button, Card, Form } from "@sscs/ui";
import { useChangePasswordForm } from "../../hooks";
import styles from "./changePasswordForm.module.scss";

const Profile = () => {
  const { onSubmit, errors, methods } = useChangePasswordForm();

  return (
    <FormProvider {...methods}>
      <Card.Card>
        <Form.Form onSubmit={onSubmit} name="change password form">
          <Card.Content className={styles["settings-form"]}>
            <Form.TextField
              type="password"
              label="Current password"
              name="currentPassword"
              id="currentPassword"
              autoComplete="current-password"
              isRequired
              errors={errors}
            />
            <Form.TextField
              type="password"
              label="New password"
              name="newPassword"
              id="newPassword"
              autoComplete="new-password"
              isRequired
              errors={errors}
            />
            <Form.TextField
              type="password"
              label="Confirm new password"
              name="confirmPassword"
              id="confirmPassword"
              autoComplete="new-password"
              isRequired
              errors={errors}
            />
          </Card.Content>
          <Card.Actions>
            <Button id="change-password" type="submit" color="primary">
              Change password
            </Button>
          </Card.Actions>
        </Form.Form>
      </Card.Card>
    </FormProvider>
  );
};

export default Profile;
